
export { default as AddFacesPanel } from './AddFacesPanel'
export { default as AddListPanel } from './AddListPanel'
export { default as AddPersonsPanel } from './AddPersonsPanel'
export { default as MatchPanel } from './MatchPanel'
export { default as VerifyPanel } from './VerifyPanel'
export { default as VerificationResults } from './VerificationResults'
export { default as MatchingResults } from './MatchingResults'



// WEBPACK FOOTER //
// ./src/components/panels/index.js